export default "__VITE_PUBLIC_ASSET__119e9487__"